export const notificationEndpoint = {
  order: "getSmsOrder",
  franchisee: "franchisee/dropdown",
  notificationHistory: "notification/history",
  notificationCount: "notification/count",
  getNotificationList: "notification/list",
  template: "notification/template",
  sendEmail: "notification/sendMail",
  sendSMS: "notification/sendSMS",
  ciName: "ci/dropdown",
  batchName: "batch/dropdown",
  studentName: "student/dropdown",
  courseLevel: "courseLevel",
  list: "sms_order/getAllFranchiseeSMSOrderList",
  create: "sms_order/createSMS",
  sendNotification: "notification/sendNotification",
  acknowledge: "notification/acknowledge",
};
